module.exports = __webpack_public_path__ + "static/media/all-priority-list.325e521c.svg";